import request from'@/utils/request.js'
export default{
    Query(data) {
        return request({
            url: '/About/Query',
            method: 'post',
            data
        })
    },
    QueryByHome(data) {
        return request({
            url: '/About/QueryByHome',
            method: 'post',
            data
        })
    }
} 